import { useEffect, useMemo } from "react"
import { useShowCustomArticleLists } from "@tm/data/basket"
import { useOwnArticlesStore } from "./store"
import { OwnListSearchType } from "./models"

export function useCompilations() {
    const { searchQuery, selectedSearchType, setCompilations } = useOwnArticlesStore()

    const request = useMemo<Parameters<typeof useShowCustomArticleLists>[0]>(
        () => ({
            listNameQuery: selectedSearchType === OwnListSearchType.List ? searchQuery : undefined,
            articleQuery: selectedSearchType === OwnListSearchType.Article ? searchQuery : undefined,
        }),
        [selectedSearchType, searchQuery]
    )

    const { data: { pages } = {}, status } = useShowCustomArticleLists(request)
    const compilations = useMemo(() => pages?.flatMap((x) => x.data?.customArticleLists), [pages])

    useEffect(() => {
        if (pages && (status === "success" || status === "error")) {
            setCompilations(pages.flatMap((x) => x.data?.customArticleLists ?? []))
        }
    }, [pages])

    const hasUnlistedItems = useMemo(() => pages?.some((x) => !!x.data.unlistedArticlesCount) ?? true, [pages])

    return { compilations, hasUnlistedItems, compilationsLoading: status === "loading" }
}
